// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"dcb276f3","527":"80b12311","537":"da0dd1dd","614":"34ccaf2e","671":"dcb276f3","807":"71638c2d"}[chunkId] + ".chunk.css";
};